export default "__VITE_ASSET__CHlyBxhh__"